import { VariantAttribute } from '@vp/upload-and-print-validator';
import { ProductOptions } from 'src/providers/ProductContextProvider';
import { getProductOptions } from 'src/services/msxService';

function getTranslationsForProductOption(translations: VariantAttribute[] | null, productOptionKey: string) {
  return translations?.find(productOption => productOption.key.key === productOptionKey);
}

export function getTranslatedNameForProductOptionValue(
  translations: VariantAttribute[] | null,
  productOptionKey: string,
  productOptionValue: string
): string | undefined {
  const translationsForOption = getTranslationsForProductOption(translations, productOptionKey);
  return translationsForOption?.value.find(value => value.key === productOptionValue)?.merchandisingName;
}

export function getTranslatedNameForProductOptionKey(
  translations: VariantAttribute[] | null,
  productOptionKey: string
): string | undefined {
  return getTranslationsForProductOption(translations, productOptionKey)?.key.merchandisingName;
}

export async function filterRecommendedProductOptionsToJustProductPageOptions(
  productKey: string,
  productVersion: number,
  recommendedProductOptions: ProductOptions
): Promise<{ [optionName: string]: string }> {
  const nonPdcProductOptions = await getProductOptions(productKey, productVersion);
  const productOptionsToAccept = Object.entries(recommendedProductOptions).filter(([key]) => {
    return nonPdcProductOptions.find(nonPdcOption => nonPdcOption.key.key === key) !== undefined;
  });
  return Object.fromEntries(productOptionsToAccept);
}

export function updateProductOptionQueryParameters(updatedOptions: { [name: string]: string }): void {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set('selectedOptions', JSON.stringify(updatedOptions));
  window.history.replaceState(null, '', `?${queryParams}`);
}
